'use strict';

/**
 * Author:fanglijuan
 * 一键快签:签发类型
 *
 * Time:2019-04-29
 */
angular.module('quickSignIssueTypeModule', []).controller('quickSignIssueTypeCtrl', ['$scope', '$sce', '$q', '$modal', '$timeout', '$state', '$location', '$window', '$filter', 'trsHttpService', '$stateParams', 'editcenterRightsService', 'modalDialog', 'editingCenterService', 'localStorageService', 'initSingleSelecet', 'appQuickSignService',
    function($scope, $sce, $q, $modal, $timeout, $state, $location, $window, $filter, trsHttpService, $stateParams, editcenterRightsService, modalDialog, editingCenterService, localStorageService, initSingleSelecet, appQuickSignService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.status = {
                keywords: '',
                copyCurrPage: 1,
            };
            $scope.params = {
                serviceid: 'mlf_appquickpublish',
                methodname: 'queryQuickPubTypes',
                keyword: '',
                SITEID: $stateParams.siteid,
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE
            };
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]null
         */
        function initData() {
            initParams();
            requestData();
        }

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.keyword = $scope.status.keywords;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = $scope.params;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
            });
        }

        /**
         * [selectAll description]全选列表
         * @return {[type]} [description] null
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [chooseItem description] 勾选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.chooseItem = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // 选择单页显示个数
        $scope.selectPageNum = function() {
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转到指定页面
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [create description]新建关联
         * @return {[type]} [description]
         */
        $scope.create = function() {
            appQuickSignService.newQuickSignType('新建新闻快签类型', $stateParams.siteid, function(result) {
                if (result.ISSUCCESS) {
                    modalDialog.multiReportsAlert(result, function() {
                        initParams();
                        requestData();
                    });
                } else {
                    initParams();
                    requestData();
                }
            });
        };
        // 还原:初始化部分参数
        function initParams() {
            $scope.params.CURRPAGE = $scope.page.CURRPAGE = $scope.status.copyCurrPage = 1;
            $scope.params.keyword = $scope.status.keywords = '';
            $scope.data.selectedArray = $scope.data.items = [];
        }

        /**
         * [delete description] 删除
         * @return {[type]}      [description]
         */
        $scope.delete = function() {
            var objectids = [];
            for (var i = $scope.data.selectedArray.length - 1; i >= 0; i--) {
                objectids.push($scope.data.selectedArray[i].APPQUICKPUBTYPEID);
            }
            var param = {
                serviceid: 'mlf_appquickpublish',
                methodname: 'deleteQuickPubTypes',
                SITEID: $stateParams.siteid,
                ObjectIds: objectids.join()
            };
            modalDialog.confirmModal('选中关联' + $scope.data.selectedArray.length + '项', '确认删除关联？', function() {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), param, 'post').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        initParams();
                        requestData();
                    });
                });
            });
        };
    }
]);
